import { DashboardModule, Form } from '@domain-group/suit-theme'

import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { generateUrls as generateProviderUrls } from '@hooks/useProvider'
import { generateUrls as generatePriceListUrls, useProviderPriceListForm } from '@hooks/useProviderPriceList'

import EntitySelector from '@components/EntitySelector'

interface ProviderPriceListDetailsProps {
  providerPriceListFormPayload: ReturnType<typeof useProviderPriceListForm>,
}

const ProviderPriceListDetails = (props: ProviderPriceListDetailsProps) => {
  const {
    providerPriceListFormPayload: {
      entityState: {
        default: isDefaultPriceList,
        expires_at,
        id,
        is_master,
        next_price_list_id,
        provider_id,
        service_id,
        soft_match_codes,
        title,
      },
      errors,
      handlers,
      setEntityState,
    },
  } = props

  const { editProviderUrl } = generateProviderUrls({ id: provider_id })
  const { editProviderPriceListUrl } = generatePriceListUrls({ id: next_price_list_id })

  return (
    <DashboardModule title="Price List Details">
      <Form padding="large">
        <Form.Row>
          <EntitySelector
            callbacks={{
              selectItem: provider => setEntityState({ provider_id: provider ? provider.id : null }),
            }}
            entityKey="providers"
            goToHref={`${editProviderUrl}?redirect=${generateRedirectUrl()}`}
            label="* Provider"
            // @ts-expect-error TS2322
            marginTop={['large', 0]}
            selectedItemId={provider_id}
          />

          <EntitySelector
            callbacks={{
              selectItem: service => setEntityState({ service_id: service ? service.id : null }),
            }}
            disabled
            entityKey="services"
            label="* Service"
            // @ts-expect-error TS2322
            marginTop={['large', 0]}
            selectedItemId={service_id}
          />
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field errorMessage={errors.soft_match_codes} label="Provider Codes">
            {/*
             // @ts-expect-error TS2322 */}
            <select data-value-type="boolean" name="soft_match_codes" value={soft_match_codes} {...handlers}>
              <option value="">Please Select...</option>
              <option value="false">Hard Match (Default)</option>
              <option value="true">Soft Match</option>
            </select>
          </Form.Field>

          <Form.Field errorMessage={errors.default} label="Default">
            {/*
             // @ts-expect-error TS2322 */}
            <select data-value-type="boolean" name="default" value={isDefaultPriceList} {...handlers}>
              <option value="">Please Select...</option>
              <option value="false">No</option>
              <option value="true">Yes</option>
            </select>
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field errorMessage={errors.title} label="* Title">
            <input name="title" value={title} type="text" {...handlers} />
          </Form.Field>

          <Form.Field errorMessage={errors.is_master} label="Master">
            {/*
             // @ts-expect-error TS2322 */}
            <select data-value-type="boolean" name="is_master" value={is_master} {...handlers}>
              <option value="">Please Select...</option>
              <option value="false">No</option>
              <option value="true">Yes</option>
            </select>
          </Form.Field>
        </Form.Row>

        {!is_master && (
          <Form.Row marginTop="large">
            <Form.Field errorMessage={errors.expires_at} label="Expiry Date">
              <input name="expires_at" value={expires_at} type="date" {...handlers} />
            </Form.Field>

            <EntitySelector
              callbacks={{
                selectItem: providerPriceList => setEntityState({
                  next_price_list_id: providerPriceList ? providerPriceList.id : null,
                }),
              }}
              entityKey="providerPriceLists"
              goToHref={`${editProviderPriceListUrl}?redirect=${generateRedirectUrl()}`}
              label="Next Price List"
              // @ts-expect-error TS2322
              marginTop={['large', 0]}
              searchRequestOptions={{
                provider_id,
                service_id,
              }}
              selectedIds={[id]}
              selectedItemId={next_price_list_id}
            />
          </Form.Row>
        )}
      </Form>
    </DashboardModule>
  )
}

export default ProviderPriceListDetails
